import { useForm } from "react-hook-form";
import Input from "@/components/ui/input";
import { useEffect, useState } from "react";
import TextArea from "@/components/ui/text-area";
import DropDown from "@/components/ui/custom-dropdown";
import React from "react";
import { useMutation } from "urql";
import { useRouter } from "next/router";

import { CREATE_NEW_CONTACT } from "@/framework/queries/contact";
import { pushLeadSuccess } from "@/lib/track";
const dropDownData = [ "Design + Build"];
const spaceTypeData = ["Villa", "Penthouse", "3–4BHK", "Duplex", "Commercial", "Other",];

export default function ContactForm() {
  const router = useRouter();
  const [processing, setProcessing] = useState(false);
  const [status, setStatus] = useState();
  const [{ error }, createNewContact] = useMutation(CREATE_NEW_CONTACT);
  // const [sourceUrl, setSourceUrl] = useState("");

  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     const url = sessionStorage.getItem("source_url");
  //     setSourceUrl(url);
  //   }
  // }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    watch,
  } = useForm();
  const lookingForValue = watch("lookingFor", "");
  const budgetValue = watch("budget", "");

  async function onSubmit(data) {

    setProcessing(true);
    try {
      const storedSourceUrl = sessionStorage.getItem("source_url") || "https://www.chalkstudio.design";
      const result = await createNewContact({
        email: data.email,
        mobile: data.mobile,
        name: data.name,
        service: data.lookingFor,
        message: data.message,
        budget: data.budget, // Add budget to payload
        city: data.city, // Add city to payload
        location: data.location, // Add location to payload
        spaceType: data.spaceType,
        source_url: storedSourceUrl, // Add source_url to payload
      });
      if (error) {
        console.log(error);
        setStatus(error);
        return;
      }
      setStatus("success");
      pushLeadSuccess(data);
      router.push("/thankyou");
    } catch (err) {
      setStatus("error");
      console.log(err);
    }
    setProcessing(false);
  }

  useEffect(() => {
    if (status === "success") {
      clearFields();
      setProcessing(false);
    } else {
      setProcessing(false);
    }
  }, [status]);

  const clearFields = () => {
    reset();
  };
  return (
    <div className="flex flex-col w-full bg-inherit">
      <form className="flex md:flex-row flex-col w-full" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="w-full flex flex-col h-full justify-start shrink-0">
          {status === "error" && (
            <div
              className="rounded md:p-12 px-4 py-8 md:text-base font-medium text-center text-red-500 text-red text-sm w-full mt-8 border-dashed border-[1px] border-red-500"
              dangerouslySetInnerHTML={{ __html: message }}
            />
          )}
          {status === "success" && (
            <div className="text-center text-darkBlue text-sm w-full border-dashed border-[1px] border-darkGrey mt-8 rounded md:p-12 px-4 py-8 md:text-base font-medium"
              dangerouslySetInnerHTML={{
                __html: "Thank you for your submission!",
              }}
            />
          )}
          {status !== "success" && status !== "error" && (
            <>
              <h2 className="md:text-lg text-base text-darkGrey/70 md:my-5 mt-0 mb-5">
                How about a quick introduction?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 auto-rows-auto gap-4 w-full mb-4">
                <Input placeholder="Full Name*" type="text" variant="solid"
                  {...register("name", {
                    required: "Please provide your full name.",
                  })}
                  errorKey={errors.name?.message} />

                <Input placeholder="Mobile Number*" type="tel" variant="solid"
                  {...register("mobile", {
                    required: `${"Please provide your mobile number"}`,
                    pattern: {
                      value: /^[6789]\d{9}$/,
                      message: "Please provide a valid mobile number",
                    },
                  })}
                  errorKey={errors.mobile?.message}
                />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 auto-rows-auto gap-4 w-full mb-2">
                <Input
                  placeholder="Email*"
                  type="string"
                  variant="solid"
                  {...register("email", {
                    required: `${"Please provide your Email"}`,
                    pattern: {
                      value:
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Please provide a valid email address",
                    },
                  })}
                  errorKey={errors.email?.message}
                />
                <div>
                  <div className="flex flex-row items-center justify-center border-[0.5px] border-solid border-darkGrey/50 w-full rounded-full relative">
                    <Input placeholder="You're looking for*" type="string" variant="solid" disabled
                      {...register("lookingFor", {
                        required: `${"Please select a Value "}`,
                      })}
                      border="border-0" />
                    <DropDown dropDownData={dropDownData} onClick={(value) => {
                      setValue("lookingFor", value);
                    }} />
                  </div>
                  {errors?.lookingFor?.message && !lookingForValue && (
                    <p className="my-2 text-xs text-red-500">
                      {errors.lookingFor?.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="w-full flex md:flex-row flex-col lg:gap-6 md:gap-8 gap-6 mt-3">
                <Input placeholder="City Name*" type="text" variant="solid"
                  {...register("city", {
                    required: "Please provide your full name.",
                  })}
                  errorKey={errors.city?.message} />
              </div>

              <div className="w-full flex md:flex-row flex-col lg:gap-6 md:gap-8 gap-6 mt-3">
                <Input placeholder="Location*" type="text" variant="solid"
                  {...register("location", {
                    required: "Please provide your location.",
                  })}
                  errorKey={errors.location?.message} />
              </div>

              <div className="w-full mt-3">
                <select
                  {...register("spaceType", {
                    required: "Please select a space type",
                  })}
                  className="w-full px-6 py-4 rounded-full border-[0.5px] border-darkGrey/50 bg-transparent outline-none"
                  defaultValue=""
                >
                  <option value="" disabled>
                    Space Type*
                  </option>

                  {spaceTypeData.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </select>

                {errors?.spaceType && (
                  <p className="my-2 text-xs text-red-500">
                    {errors.spaceType.message}
                  </p>
                )}
              </div>

              <div className="w-full flex md:flex-row flex-col lg:gap-6 md:gap-8 gap-6 my-4">
                <TextArea placeholder="Write your message here*" variant="solid"
                  {...register("message", {
                    required: "Please provide your message.",
                  })}
                  errorKey={errors.message?.message}
                />
              </div>

              {lookingForValue === "Design Only" && (
                <div className="w-full flex md:flex-row flex-col lg:gap-6 md:gap-8 gap-6 my-1">
                  <div className="mb-4">
                    <h3 className="md:text-lg text-base text-darkGrey/70 md:my-3 mt-0 mb-2">Budget*</h3>
                    <p style={{ fontSize: ".875rem", lineHeight: "1.25" }} className="mb-3 text-darkGrey/70">The budget below covers our design fee only. Actual execution, materials, and labour are separate costs. Select <b className="text-black">Design + Build</b> if you want us to handle everything.</p>
                    <div className="flex gap-4 flex-wrap">

                      {/* <label className={`px-8 py-3 border rounded cursor-pointer text-sm ${budgetValue === "5 Lakh" ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"}`}>
                        <input type="radio" value="5 Lakh"
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        5 Lakh
                      </label> */}

                      <label className={`px-8 py-3 border rounded cursor-pointer text-sm ${budgetValue === "15 Lakh" ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"
                        }`}>
                        <input type="radio" value="15 Lakh"
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        15 Lakh
                      </label>

                      <label className={`px-8 py-3 border rounded cursor-pointer text-sm ${budgetValue === "20 Lakh" ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"}`}>
                        <input type="radio" value="20 Lakh"
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        20 Lakh
                      </label>

                      <label className={`px-8 py-3 border rounded cursor-pointer text-sm ${budgetValue === "Above 20 Lakh" ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"}`}>
                        <input type="radio" value="Above 20 Lakh"
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        Above 20 Lakh
                      </label>
                    </div>
                    {errors.budget && <p className="text-red-500 text-sm mt-2">{errors.budget.message}</p>}
                  </div>
                </div>
              )}

              {lookingForValue === "Design + Build" && (
                <div className="w-full flex md:flex-row flex-col lg:gap-6 md:gap-8 gap-6 my-1">
                  <div className="mb-4">
                    <h3 className="md:text-lg text-base text-darkGrey/70 md:my-3 mt-0 mb-2">Budget*</h3>
                    <div className="flex gap-3 flex-wrap">

                      {/*<label className={`px-5 py-3 border rounded cursor-pointer text-sm ${budgetValue === "65 Lakh" ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"}`}>
                        <input type="radio" value="65 Lakh"
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        65 Lakh
                      </label> */}

                      {/* <label className={`px-8 py-3 border rounded cursor-pointer text-sm ${budgetValue === "75 Lakh" ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"}`}>
                        <input type="radio" value="75 Lakh"
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        75 Lakh
                      </label> */}

                      <label className={`px-8 py-3 border rounded cursor-pointer text-sm ${budgetValue === "1 Cr." ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"
                        }`}>
                        <input type="radio" value="1 Cr."
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        1 Cr.
                      </label>

                      <label className={`px-8 py-3 border rounded cursor-pointer text-sm ${budgetValue === "2 Cr." ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"}`}>
                        <input type="radio" value="2 Cr."
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        2 Cr.
                      </label>

                      <label className={`px-8 py-3 border rounded cursor-pointer text-sm ${budgetValue === "3 Cr. & Above" ? "border-blue-500 bg-darkGrey text-[#f6f5f1]" : "border-gray-300"}`}>
                        <input type="radio" value="3 Cr. & Above"
                          {...register("budget", { required: "Please select a budget." })}
                          className="hidden" />
                        3 Cr. & Above
                      </label>
                    </div>
                    {errors.budget && <p className="text-red-500 text-sm mt-2">{errors.budget.message}</p>}
                  </div>
                </div>
              )}

              <button
                className="hover:bg-darkGrey mx-auto bg-beige text-darkGrey transition-all duration-300 ease w-full py-3 hover:text-[#f6f5f1] md:w-[150px] rounded-full"
                type="submit"
              >
                {processing ? "Submitting..." : `Submit`}
              </button>
            </>
          )}
        </div>
      </form>
    </div>
  );
}
